import { FC, memo } from 'react';
import cx from 'clsx';

import { Icon } from 'src/components/Icon';

import styles from './styles.module.css';
import { Logo } from 'src/components/Logo';
import { useTogglePreview } from 'src/hooks';

export const TopBar: FC = memo(() => {
  const { togglePreview } = useTogglePreview();

  return (
    <>
      <div className={styles.topBar}>
        <button
          name="back"
          className={styles.button}
          type="button"
          onClick={togglePreview}
        >
          <Icon className={cx(styles.icon, styles.iconBack)} name="back" />
        </button>

        <div className={styles.logo}>
          <Logo />
        </div>
      </div>
    </>
  );
});
